type FeatureFlag = {
  featureName: FeatureFlagName;
  customerId: string;
  isEnabled: boolean;
  expiration?: number | null;
};

export enum FeatureFlagName {
  Transcription = "Transcription",
  BulkExport = "BulkExport",
  Views = "Views",
}

export const FEATURE_FLAG_LABELS: Record<FeatureFlagName, string> = {
  [FeatureFlagName.Transcription]: "Transcription",
  [FeatureFlagName.BulkExport]: "Bulk Export",
  [FeatureFlagName.Views]: "Views",
};

export default FeatureFlag;
